//@ts-check

import React from "react";
// import { StyleSheet, Text, View } from "react-native";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Login from "../screens/Login";
import ValidateDevice from "../screens/ValidateDevice";

import { connect, useSelector } from "react-redux";
import MainRouter from "./mainRouter";
import { deviceStore } from "../mock/deviceStore";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useConnectionStateListener,
} from "ably/react";

const EntryRouter = (props) => {
  const { isAuthenticated, analyst_id } = props;
  const [deviceCleared, setDeviceCleared] = React.useState(false);

  const showValidateDevice =
    isAuthenticated &&
    !deviceCleared &&
    !deviceStore.hasRequest(analyst_id);

  return (
    <ChannelProvider channelName={"analyst_portal_" + analyst_id}>
      <Router>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route
            path="/"
            render={({ location }) => {
              if (!isAuthenticated) {
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: location },
                    }}
                  />
                );
              }
              // if (showValidateDevice) {
              //   return (
              //     <ValidateDevice onRequestSent={() => setDeviceCleared(true)} />
              //   );
              // }
              return <MainRouter />;
            }}
          />
        </Switch>
      </Router>
    </ChannelProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    analyst_id: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {})(EntryRouter);
